import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { API_URL } from '../apiConfig';

const JournalForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    journalEntry: '',
    style: 'cozy-pink',
    customBackground: null
  });
  const [imagePreview, setImagePreview] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const styles = [
    { value: 'plain', label: '🌸 Plain', emoji: '🌸' },
    { value: 'medieval', label: '⚔️ Medieval', emoji: '⚔️' },
    { value: 'angelic', label: '👼 Angelic', emoji: '👼' },
    { value: 'cozy', label: '☕ Cozy', emoji: '☕' },
    { value: 'cozy-pink', label: '💕 Cozy Pink', emoji: '💕' },
    { value: 'night-cozy', label: '🌙 Night Cozy', emoji: '🌙' },
    { value: 'aggressive', label: '🔥 Aggressive', emoji: '🔥' },
    { value: 'sad', label: '💙 Sad', emoji: '💙' },
    { value: 'super-happy', label: '🌈 Super Happy', emoji: '🌈' },
    { value: 'custom', label: '🎨 Custom', emoji: '🎨' }
  ];

  const handleImageUpload = (e) => {
  const file = e.target.files[0];
  if (file) {
   
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);
      setFormData({ ...formData, customBackground: reader.result });
    };
    reader.readAsDataURL(file);
  }
};
 const handleSubmit = async (e) => {
  e.preventDefault();
  
  if (!formData.email || !formData.journalEntry) {
    toast.error('Please fill out all fields!');
    return;
  }

  setIsSubmitting(true);
  
  try {
    const response = await fetch(`${API_URL}/api/send-journal`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    const data = await response.json();

    if (response.ok) {
      toast.success('Journal entry sent to your email! Thank you for using voxtek journals!! 💌');
      setFormData({ email: '', journalEntry: '', style: 'cozy-pink' });
    } else {
      toast.error(data.error || 'Something went wrong!');
    }
  } catch (error) {
    console.error('Error sending journal:', error);
    toast.error('Failed to send journal entry');
  } finally {
    setIsSubmitting(false);
  }
};

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-orange-50 to-yellow-50 py-12 px-5">
      <div className="max-w-3xl mx-auto">
        
        <div className="text-center mb-8">
          <h1 className="text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-pink-500 to-rose-400 bg-clip-text text-transparent mb-3">
            ✨ Write Your Journal Entry ✨
          </h1>
          <p className="text-purple-800 text-lg">
            (Come onnn! U know u wanna!!!)
          </p>
        </div>

      
        <form onSubmit={handleSubmit} className="bg-white rounded-3xl shadow-xl p-8 space-y-6">
     
          <div>
            <label className="block text-rose-400 font-semibold text-lg mb-2">
              📧 Your Email
            </label>
            <input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              placeholder="where should we send your journal?"
              className="w-full px-5 py-3 border-2 border-pink-200 rounded-2xl focus:outline-none focus:border-pink-400 transition-colors text-gray-700"
              required
            />
            <p className="text-sm text-gray-500 mt-2">
              💡 Your journal entry is never saved on our database - it goes straight to your inbox!!!
            </p>
          </div>

       
          <div>
            <label className="block text-rose-400 font-semibold text-lg mb-2">
              📝 Your Thoughts
            </label>
            <textarea
              value={formData.journalEntry}
              onChange={(e) => setFormData({ ...formData, journalEntry: e.target.value })}
              placeholder="write whatever's on your mind... no judgment, just you and your thoughts...and ur best friend, Steve! ✨"
              rows="12"
              className="w-full px-5 py-3 border-2 border-pink-200 rounded-2xl focus:outline-none focus:border-pink-400 transition-colors text-gray-700 resize-none"
              required
            />
            <p className="text-sm text-gray-400 mt-2">
              {formData.journalEntry.length} characters
            </p>
          </div>

        
          <div>
            <label className="block text-rose-400 font-semibold text-lg mb-3">
              🎨 Pick Your Vibe
            </label>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
              {styles.map((style) => (
                <button
                  key={style.value}
                  type="button"
                  onClick={() => setFormData({ ...formData, style: style.value })}
                  className={`p-4 rounded-xl border-2 transition-all duration-200 ${
                    formData.style === style.value
                      ? 'border-pink-400 bg-pink-50 shadow-md scale-105'
                      : 'border-pink-200 bg-white hover:border-pink-300 hover:bg-pink-50'
                  }`}
                >
                  <div className="text-3xl mb-1">{style.emoji}</div>
                  <div className="text-sm font-medium text-gray-700">
                    {style.label.replace(style.emoji + ' ', '')}
                  </div>
                </button>
              ))}
            </div>
          </div>
 {formData.style === 'custom' && (
            <div className="bg-pink-50 p-6 rounded-2xl border-2 border-pink-200">
              <label className="block text-rose-400 font-semibold text-lg mb-2">
                🖼️ Upload Your Background
              </label>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
                className="w-full px-5 py-3 border-2 border-pink-200 rounded-2xl focus:outline-none focus:border-pink-400 transition-colors bg-white"
              />
              <p className="text-sm text-gray-500 mt-2">
                Upload an image to use as your journal background! We'll automatically adjust text colors for readability ✨
              </p>
              {imagePreview && (
                <div className="mt-4">
                  <p className="text-sm text-gray-600 mb-2 font-semibold">Preview:</p>
                  <img 
                    src={imagePreview} 
                    alt="Background preview" 
                    className="w-full h-48 object-cover rounded-xl border-2 border-pink-300"
                  />
                </div>
              )}
            </div>
          )}
       
          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-gradient-to-r from-pink-500 to-rose-400 text-white py-4 rounded-2xl font-semibold text-lg shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
          >
            {isSubmitting ? 'Sending... ✨' : 'Send to My Inbox 💌'}
          </button>
        </form>

        <div className="text-center mt-6">
          <button
            onClick={() => navigate('/')}
            className="text-purple-600 hover:text-purple-800 font-medium"
          >
            ← Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default JournalForm;
